import React from 'react';
import { List } from '@printdeal/ui-library';
import { FooterLink } from './FooterLink';
import {
  dispatchDataLayerEventOnNavigationClick,
  dispatchDataLayerEventOnNavigationLinkClickGA4,
} from '../helpers';

interface ItemProps {
  items?: ItemProps[];
  title?: string;
  icon?: string;
  url?: string;
  openInNewTab?: boolean;
  children?: {
    path?: string;
  };
}

interface FooterLinkSectionProps {
  section: {
    title?: string;
    icon?: string;
    url?: string;
    openInNewTab?: boolean;
    children?: Object;
    items?: ItemProps[];
  }
}

const handleOnClick = (itemTitle: string) => {
  const NAVIGATION_EXTENDED_FOOTER = 'navigation_extended_footer';

  const eventPayload = {
    navType: NAVIGATION_EXTENDED_FOOTER,
    eventLabel: itemTitle,
  };
  dispatchDataLayerEventOnNavigationClick(eventPayload);
  dispatchDataLayerEventOnNavigationLinkClickGA4(NAVIGATION_EXTENDED_FOOTER, itemTitle);
};

const FooterLinkSection = ({ section }: FooterLinkSectionProps) => {
  const { items: sectionItems } = section;

  if (!sectionItems || sectionItems.length === 0) {
    return null;
  }

  return (
    <List variant="icon">
      {sectionItems.map((item) => {
        const { title, items } = item;
        const displayItem = items ? items[0] : item;
        const { url, openInNewTab, children } = displayItem;
        const path = children?.path;

        return (
          <FooterLink
            key={item.title}
            title={title}
            url={url}
            openInNewTab={openInNewTab}
            path={path}
            onClick={handleOnClick}
          />
        );
      })}
    </List>
  );
};

export default FooterLinkSection;
